import ErrorBoundary from "@/components/error-boundries/error-boundry-comp";
import CreateMeetsComp from "@/components/v2/create-meets/create-meets-comp";
import DefaultLayout from "@/layouts/default-layout";
import { Button } from "@heroui/react";
import { X } from "lucide-react";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { cn } from "tailwind-variants";

const CreateMeetingPage = () => {
  const navigate = useNavigate();
  const isDark = document.documentElement.classList.contains("dark");
  return (
    <>
      <div className="relative h-screen">
        <Button
          type="button"
          variant="ghost"
          isIconOnly
          onPress={() => navigate(-1)}
          className={
            "absolute z-20 top-4 right-5 icon-button glass-surface !text-[#71717A] flex items-center justify-center dark:text-white! rounded-full!"
          }
        >
          <X className="size-4 mb-0 mt-.5" />
        </Button>
        <div className="relative z-10 p-4 pb-0 h-full">
          <ErrorBoundary>
            <CreateMeetsComp _onResp={null} />
          </ErrorBoundary>
        </div>

        <img
          src={isDark ? "/create-meets-bg-dark.png" : "/create-meets-bg.png"}
          className="absolute inset-0 w-full h-full object-cover z-0"
          style={{ opacity: isDark ? 1 : 0.7 }}
        />

        {!isDark && (
          <div className="bg-white/10 h-screen w-screen z-2 backdrop-blur-[100px] absolute inset-0 top-0 left-0 right-0" />
        )}
      </div>
    </>
  );
};

export default CreateMeetingPage;
